module.exports = __webpack_public_path__ + "img/step46_switch_beam_power-edit-1.b7c05b19.png";